import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].GET_PHOTOS]: {
		url: '/company/:companyId/machines/:machineId/photos/',
	},
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].GET_PHOTO]: {
		url: '/company/:companyId/machines/:machineId/photos/:photosId/',
	},
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].CREATE_PHOTO]: {
		url: '/company/:companyId/machines/:machineId/photos/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].PATCH_PHOTO]: {
		url: '/company/:companyId/machines/:machineId/photos/:photosId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].PUT_PHOTO]: {
		url: '/company/:companyId/machines/:machineId/photos/:photosId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].DELETE_PHOTO]: {
		url: '/company/:companyId/machines/:machineId/photos/:photosId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
